var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fm-tree scroll"},[_c('branch',{attrs:{"parent-id":0},on:{"selected":_vm.onPathSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }